import { cn } from '@sohanemon/utils';
import { Chip } from '@sohanscript/ui/chip';
import type { ComponentProps } from 'react';

type StackPillsProps = ComponentProps<'div'> & {
	items: string[];
	limit?: number;
};

export function StackPills({
	items,
	limit,
	className,
	...props
}: StackPillsProps) {
	const shown = typeof limit === 'number' ? items.slice(0, limit) : items;
	return (
		<div className={cn('flex flex-wrap gap-1.5', className)} {...props}>
			{shown.map((tech) => (
				<Chip
					key={tech}
					className="border border-primary/20 bg-primary/5 px-2 text-primary/80"
				>
					{tech}
				</Chip>
			))}
		</div>
	);
}
